export function NavTopCaret(): React.ReactNode {
  return (
    <div className="nav-caret-clip absolute top-[-13px] z-[100] mx-auto hidden rotate-180 p-1 sm:-right-3 sm:block">
      <div className="size-4 rotate-45 rounded-[4px] border border-base-white/10 bg-base-primary focus:outline-none" />
    </div>
  );
}
